export const focusedNewConversationsRollupText = "tUa";
export const otherNewConversationsRollupText = "uUa";
export const focusedNewMessagesRollupText = "vUa";
export const otherNewMessagesRollupText = "wUa";
export default {focusedNewConversationsRollupText,otherNewConversationsRollupText,focusedNewMessagesRollupText,otherNewMessagesRollupText};